@if (contentListSource.pageItems.length && !triggerAnimation) {
  <ul class="content-list-source-array-thumbnail">
    @for (pageItem of contentListSource.pageItems; track $index) {
      <li class="content-list-source-array__item">
        <div class="list-thumbnail__item">
          <div
            class="list-thumbnail__row"
            [@animateHeight]="pageItem.listItem.expanded ? 'expand' : 'collapse'"
          >
            <div
              class="content-list-source-array-thumbnail__first-column"
              [ngClass]="{'relatedObjectView': pageItem.relatedObject,
                          'hasExpandButton': pageItem.listItem.showExpandButton,
                          'overflown': pageItem.listItem.showExpandButton && !pageItem.listItem.expanded}"
              #secondContent
            >
              <div class="list-thumbnail__first-container">
                @if (hasOperationMenu) {
                  <div class="checkbox-underlay">
                    <mat-checkbox
                      class="white-bg-in-checkbox"
                      [disabled]="contentListSource.operationContainer.art.read_only"
                      [(ngModel)]="pageItem.checked"
                      (ngModelChange)="setSelected($event, pageItem)"
                      [checked]="pageItem.checked"
                    ></mat-checkbox>
                  </div>
                }

                <app-object-url
                  [object]="pageItem.relatedObject"
                  [aClass]="'thumbnail-url-source-content'"
                  class="content-list-source-array-thumbnail__object-url"
                >
                  <div class="object-url-content">
                    @if (pageItem.thumbnailInfo.thumbnail_url || pageItem.thumbnailInfo.thumbnail_id) {
                      <app-thumbnail
                        [item]="pageItem.thumbnailInfo"
                        [stylingClass]="'thumbnail-image thumbnail-fixed-height'"
                      ></app-thumbnail>
                    }
                    @else {
                      <i class="icon-image imgIcon"></i>
                    }
                  </div>
                </app-object-url>
              </div>

              <div
                class="list-thumbnail__second-container"
                [ngClass]="{'overflown': pageItem.listItem.showExpandButton && !pageItem.listItem.expanded}"
              >
                <div class="list-thumbnail__object-overview">
                  @if (pageItem.relatedObject.overview) {
                    <app-object-content-list-overview-fields
                      [objectView]="pageItem.relatedObject"
                    ></app-object-content-list-overview-fields>
                  }
                </div>
              </div>
            </div>

            <div
              class="content-list-source-array-thumbnail__second-column"
              #thirdContent
              [ngClass]="{'overflown': pageItem.listItem.showExpandButton && !pageItem.listItem.expanded,
                          'hasExpandButton': pageItem.listItem.showExpandButton}"
            >
              <div class="list-thumbnail__object-overview">
                <div class="headline-container">
                  <i class="icon-link"></i>

                  <span class="bold">
                    {{ 'TRANS__OBJECT_CONTENT_LIST_SOURCE_ARRAY_ITEMS__RELATION_HEADLINE' | translate }}
                  </span>
                </div>

                <ul class="content-list-source-array-thumbnail__second-column-items">
                  @for (field of pageItem.listItem.fields; track $index) {
                    <li>
                      <span class="content-list-source-array-thumbnail__second-column-item-title">
                        {{field.title | translate}}:
                      </span>

                      <span>
                        {{field.value}}
                      </span>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>

          @if (pageItem.listItem.showExpandButton) {
            <button
              (click)="toggleExpand(pageItem)"
              mat-button
              class="expand-button"
            >
              @if (pageItem.listItem.expanded) {
                <span>
                  {{ 'TRANS__OBJECT_CONTENT_LIST_SOURCE_ARRAY_ITEMS__SHOW_LESS' | translate }}
                </span>
              }
              @else {
                <span>
                  {{ 'TRANS__OBJECT_CONTENT_LIST_SOURCE_ARRAY_ITEMS__SHOW_MORE' | translate }}
                </span>
              }
            </button>
          }
        </div>
      </li>
    }
  </ul>
}




